import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';

// React 19 root. The whole Pages app is a SPA under BrowserRouter; the Pages
// Functions handle /auth/start (cookie mint) and /api/* (session-injected
// proxy to the Worker). Everything else is client-side routing.
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element missing');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
